var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "k-page",
    { staticClass: "post contact" },
    [
      _c(
        "d-main-image",
        _vm._b(
          { on: { load: _vm.pageLoaded } },
          "d-main-image",
          { img: _vm.img, show: _vm.show },
          false
        )
      ),
      _c("w-go-down"),
      _c(
        "k-main",
        { attrs: { title: _vm.title } },
        [
          _c("section", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(_vm.content) },
          }),
          _vm._l(_vm.posts, function (post) {
            return _c("section", { key: post.id, staticClass: "post" }, [
              _c("h2", {
                staticClass: "title fancy-title",
                domProps: { innerHTML: _vm._s(_vm.postTitle(post)) },
              }),
              _c("div", {
                staticClass: "content",
                domProps: { innerHTML: _vm._s(_vm.postContent(post)) },
              }),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }